import { ApiRequestError } from '@frodo/lib/services/http/error/ApiRequestError';
import type { ActionMessage } from '@frodo/models/types';
import { DEFAULT_ERROR_MESSAGE } from '@frodo/lib/utils/common/constants';

const isActionMessage = (value: unknown): value is ActionMessage =>
  typeof (value as ActionMessage | undefined)?.text === 'string';

export const getActionErrorMessage = (error: unknown): ActionMessage => {
  const defaultErrorMessage: ActionMessage = {
    text: DEFAULT_ERROR_MESSAGE,
    type: 'error',
  };

  if (!(error instanceof ApiRequestError)) {
    return defaultErrorMessage;
  }

  const message = (error.data as { message?: unknown } | undefined)?.message;

  return isActionMessage(message) ? message : defaultErrorMessage;
};
